import React, { Suspense } from 'react';
import { Box } from '@cad-arc';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { lazyLoadFederatedSearchModule } from './federated-search-remote-monitor';
import { ErrorBoundary } from '../monitoring/error-boundary';

type MoreActionsMenuType = typeof import('federated-search/MoreActionsMenu').MoreActionsMenu;

const MoreActionsMenu = lazyLoadFederatedSearchModule<MoreActionsMenuType>(
    'MoreActionsMenu',
    () => import('federated-search/MoreActionsMenu'),
    (module) => module.MoreActionsMenu as MoreActionsMenuType,
    () => null
);

export const FederatedSearchMoreActionsMenu = () => (
    <Box data-testid="federated-search-more-actions-menu">
        <ErrorBoundary
            name="FEDERATED_SEARCH_MORE_ACTIONS_MENU"
            extraTags={{ feature: 'federated-search' }}
            fallback={() => null}
        >
            <Suspense fallback={<LoadingIndicator />}>
                <MoreActionsMenu />
            </Suspense>
        </ErrorBoundary>
    </Box>
);
